export default {

    updateIsLoading(state, payload) {
        state.isLoading = payload;
    },

    updateSelected(state, payload) {
        state.selected = payload;
    },

    resetSelected(state, payload) {
        state.selected = [];
    },

    appendSelected(state, payload) {
        state.selected.push(payload);
    },

    removeSelected(state, payload) {
        let index = state.selected.findIndex(item => {
            return item[payload.trackBy] == payload.data[payload.trackBy];
        });

        state.selected.splice(index, 1);
    },

    removeSelectedPanel(state, payload) {
        state.selected.splice(state.selected.indexOf(payload), 1);
    },

    updateData(state, payload) {
        state.data = payload;
    },

    concatData(state, payload) {
        state.data = state.data.concat(payload);
    },

    concatDataDedupe(state, payload) {
        state.selected = [...new Set(state.selected.concat(payload))];
    },

    prependData(state, payload) {
        state.data = payload.concat(state.data);
    },

    resetData(state, payload) {
        state.data = [];
    },

    removeData(state, payload) {
        const index = state.data.findIndex(item => {
            return item[payload.trackBy] == payload.value;
        });

        state.data.splice(index, 1);
    }
}